export const reports = "/reports";
export const root = "/";
export const settings = "/settings";
export const goals = "/goals";
export const timesheet = "/timesheet";
export const orgApprovals = "/org/approvals";
export const orgReports = "/org/reports";
export const teamRoles = "/team/roles";
export const teamPeople = "/team/people";
export const team = "/team";
export const admin = "/admin/users";
